export default __webpack_public_path__ + "static/media/mysql.9e6f407a.jpg";